import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import LinkForm from './LinkForm';
import LinkList from './LinkList';
import './Dashboard.css';

const Dashboard = () => {
  const { user, logout } = useAuth();
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLinks();
  }, []);

  const fetchLinks = async () => {
    try {
      const response = await api.get('/links');
      setLinks(response.data);
    } catch (error) {
      console.error('Erro ao buscar links:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleLinkCreated = (newLink) => {
    console.log('Adicionando novo link à lista:', newLink);
    setLinks([newLink, ...links]);
    console.log('Lista de links atualizada');
  };

  const handleLinkDeleted = async (linkId) => {
    try {
      await api.delete(`/links/${linkId}`);
      setLinks(links.filter(link => link.id !== linkId));
    } catch (error) {
      console.error('Erro ao deletar link:', error);
      alert(error.response?.data?.error || 'Não foi possível deletar o link. Tente novamente.');
    }
  };

  const getShortUrl = (shortCode) => {
    // Em desenvolvimento, usar a porta do backend (5000)
    // Em produção, usar a mesma origem (nginx faz proxy)
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 
      (process.env.NODE_ENV === 'production' 
        ? window.location.origin 
        : 'http://localhost:5000');
    return `${backendUrl}/${shortCode}`;
  };

  return (
    <div className="dashboard">
      <header className="dashboard-header">
        <div className="header-content">
          <h1>Encurtador de Links</h1>
          <div className="user-info">
            <span>Olá, {user?.username}</span>
            <button onClick={logout} className="logout-button">
              Sair
            </button>
          </div>
        </div>
      </header>

      <div className="dashboard-content">
        <div className="main-section">
          <LinkForm onLinkCreated={handleLinkCreated} />
          
          <LinkList
            links={links}
            loading={loading}
            onDelete={handleLinkDeleted}
            getShortUrl={getShortUrl}
          />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;

